/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch, useSelector} from 'react-redux' // Added for CHG0073013
import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import axios from "axios";
import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import { useHistory } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SearchOutlined } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MdReplay } from 'react-icons/md';
import TablePagination from "@mui/material/TablePagination"; 
import styles from './ReportNoPO.module.css';
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { API } from '../../apis/api'
import TextIcon from './TextIcon'
import { buildErrorMessage } from '../../apis/calls'
import Table from '../Table/Table';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import { setToast, setPORow, poSearch, fetchChassis, setChassisData, setAllDetails, getInvoice } from '../../redux/actions/productsActions';
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import ReportTable from '../ReportTableComponent/ReportTable';
import { sanitizeCoCodeNumeric } from '../../utils/utils';




const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: '',
  supplierLocation: '',
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: '',
    suppRepresentativeName: '',
    suppRepresentativeContact: '',
    suppRepresentativeEmail: ''
  },
  errors: {},
}
const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        [action.field]: action.value
      }
    case 'reset':
      return {
        ...state,
        ...initialState
      }
    default:
      return state
  }
}

function ReportNoManager({ redirectToProcessPage, product, counter, baseUrl, auth }) {
  const ROW_HEIGHT = 38;
 
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const dispatchNew= useDispatch();
  const history = useHistory();
  const authData = useSelector((state) => state.auth); // Added for CHG0073013



  const { damage, invoice, plant, part, aqCommodity, purchaseCommodity, supplierCode, supplierDetails, supplierName,
    supplierLocation, selectedProject, selectedPO, inputFields, errors } = state;

  const [loading, setLoading] = React.useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);


  const [toggle, setToggle] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([])
  const [companyCodeOption, setCompanyCode] = useState([]);

  const HEIGHT = '250px';
  const FILENAME = 'No_Linkage_Report';

  const [myState, setState] = React.useState(
    {
      poNo: "",
      stmNo: "",
      chassisNo: null,
      fromDate: moment().startOf('month').format(DATE_FORMAT.YYYY_MM_DD), // Added for CHG0073013
      toDate: moment().format(DATE_FORMAT.YYYY_MM_DD), // Added for CHG0073013
      bodyBuilder: null,
      checkFlag: false

    });
    let {
      userName,
      personNumber,
      companyCode,
      userRole,
      } = auth;
  
  const setCount = count => {
    setAsnCount(count);
  };
  const handleDate = (date, name) => {
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;

    }
    let newDate = date.format(DATE_FORMAT.ISO)
    setState((prevData) => ({ ...prevData, [name]: date }));

  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const resetError = (name) => {
    if (name == "chassisNo") {
      strflag();
    }
  }

  
  useEffect(() => {
    setViewDisplay(true);
  }, []);


  const strflag = () => {
    var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
    let str = myState.chassisNo;
    if (myState.chassisNo == "") {
      return
    }

    if (regexp.test(str)) {


      setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }))
      return true
    }
    else {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }))
      return false

    }

  }

  const convert2 = (str) => {
    if (str == null) {
      return '';
    } else {


      const date = new Date(str);
      const mnth = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);
      //  return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29 

      return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  }

  useEffect(()=>{
    getCheckValidDate()
  },[])

  const getCheckValidDate = () => {
    setLoading(true)
    let data={}
    axios
      .post(`${baseUrl}timeBooking/checkValidDate`,data,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      })
     
      .then((response) => {
        dispatchNew(setLogin({ ...auth, recentStatus: response.status }));
        if(response.data.msg==="Success" && response?.data?.data?.length > 0){
          setLoading(false)
          setState((pre)=>({
            ...pre,
            fromDate:moment(response?.data?.data[0][0],"YYYY-MM-DD").format("MM-DD-YYYY"),
            toDate:moment(response?.data?.data[0][1],"YYYY-MM-DD").format("MM-DD-YYYY")
          }))
        }
        else if(response.data.msg=="Fail")  {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later.",
        })
        }
      })
      .catch((error) => {
        setLoading(false);
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
       if (error.response.status === 403) {
          // Handle 403 Forbidden
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        }else if (error.response.status === 423){
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        }else if (error.response.status === 503){
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        }  else {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later.",
        })
          // Handle other HTTP errors
          console.error("Error response data:", error.response.data);
        }
     
      });
  };




  const handleSubmit = async () => {
    setLoading(true);
    setState((prevState) => ({ ...prevState, tableFlag: true }));
    setViewDisplay(true);
    setRowsPerPage(10)
 
    let fromDate = convert2(myState.fromDate);
    let toDate = convert2(myState.toDate);

    if (fromDate == "" || toDate == "") {
      setLoading(false);
      setAllTableData([])
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please Enter a date"
      });
      return
    }
    const isSameOrAfter = moment(fromDate).isAfter(toDate);
   
    if (isSameOrAfter) {
       setLoading(false)
       setTableArray([])
       setAllTableData([])
       showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "End Date Should Be Greater Than  Or Equal To Start Date",
      });
      }
      
    else{
    let apiFormatedData = {
    co_code: sanitizeCoCodeNumeric(companyCode),
    user_role:authData?.userRole, // Added for CHG0073013
    pers_no: authData?.personNumber, // Added for CHG0073013
    dtfrom: moment(fromDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
    dtTo: moment(toDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
  };
  var apiFormatedDataJson = JSON.stringify(apiFormatedData);
  let headerss = new Headers();
  headerss.append("Content-Type", "application/json");
  fetch(`${baseUrl}reports/NoLinkageReport`, {
    method: "POST",
    headers: headerss,
    credentials:"include",
    body: apiFormatedDataJson,
  })
    .then((response) => {
      setLoading(false);
      dispatchNew(setLogin({...auth, recentStatus: response.status}))
      let responsecode=response.status
      if(responsecode===403){
        setLoading(false);
      }
      return response.json();
      })
    .then((responseJson) => {
      if (responseJson.msg=="Success" && responseJson.data.length != 0) {
        setLoading(false);
        setState((prevState) => ({ ...prevState, tableFlag: true }));
        const finalList = [];
        responseJson.data.map((row, index) => {
          finalList.push({
            id: index,
            ...row,
          });
        });
        setAllTableData(finalList)
        setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
      }
      else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
        setAllTableData([])
        setLoading(false);
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "No Records Found",
      })
      }
       else if(responseJson && responseJson.msg=="Fail")  {
        setAllTableData([])
        setLoading(false);
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: responseJson.data,
      })
      }
      setState((prevState) => ({ ...prevState, tableFlag: true }));
    }).catch((error) => {
      setLoading(false);
      setAllTableData([])
      if (error.response) {
        showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Oops! Something went wrong. Please try again later. Please try again later",
            })
      }
      else {
        showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "There might be Network issue, please try after some time",
          })
      }
    });
    };
  }

  const BG_COLOR = '#fffef8';
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors(prev => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field)
          newBackgroundColors[key] = true;
        else
          newBackgroundColors[key] = false;
      }
      return newBackgroundColors
    })


 
  const handleOpen = () =>{
    window.location.reload()
    // setIsPopupOpen(true)
    setTableArray([])
  } ;
  const handleClose = () => setIsPopupOpen(false);
  const handleOpen1 = () => {
    setConfirmModal(true);


  };
  
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if(myState.checkFlag==true){
      setState((prevData) => ({
        ...prevData, 
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData, 
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }
 
    setTableData([])
    setHighlightMandatoryFields(false)

  }

  const processProjectList = projectList => {
    let processedProjectList = projectList.map(({ ...project }) => {
      const allPlants = project.plants.map(item => item.name);
      const allVehicleLines = project.vehicleLines;
      const projectCreationDate = moment(project.createdAt).format("DD/MM/YYYY");
      return {
        id: project.id,
        ...project,
        allPlants,
        allVehicleLines,
        projectCreationDate
      }
    });
    const allPlantsList = [];
    const allVehicleLineList = [];
    processedProjectList.forEach(({ allPlants, vehicleLines }) => {
      allPlantsList.push(...allPlants);
      allVehicleLineList.push(...vehicleLines);
    });

    processedProjectList = processedProjectList.map(({ ...project }) => (
      {
        ...project,
        allPlants: [...new Set(allPlantsList)],
        allVehicleLines: [...new Set(allVehicleLineList)],
      }
    ));
    return processedProjectList;
  }
 
  const baseDefaultColumns = [
    {
      width: 120,
      title: 'Ticket No',
      field: 'pers_no',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: 'Employee Name',
      field: 'empl_name',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: 'Work Area',
      field: 'workarea',
      enableSearch: true,
      enableFilter: true,
    }, 
    {
      width: 100,
      title: 'BC No',
      field: 'bc_number',
      enableSearch: true,
      enableFilter: true,
    },

    { 
      width: 280,
      title: 'BC Description',
      field: 'bc_name',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Grade Group',
      field: 'grade_group',
      enableSearch: true,
      enableFilter: true,
    },

    { 
      width: 100,
      title: 'Company',
      field: 'company',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 130,
      title: 'Location',
      field: 'location',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Month',
      field: 'mon',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Exception Hours',
      field: 'exception_hrs',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Status',
      field: 'status',
      enableSearch: true,
      enableFilter: true,
    },

  ];


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };
useEffect(()=>{
  handleSubmit()
},[]) // Added for CHG0073013
  const renderOther = () => (
    <div
      className={styles.formGroup}
      onClick={() => changeBackgroundColor('processInfoBg')}
    >
      {/* Removed for CHG0073013  */}
      {/* <Grid
        container
        spacing={1}

        style={{ display: 'flex', justifyContent: "left", marginTop: "10px" }}
        columns={12}
        className={styles.myGrid}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                autoOk
                inputVariant="outlined"
                value={myState.fromDate}
                onChange={(e) => { handleDate(e, 'fromDate') }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                autoOk
                inputVariant="outlined"
                value={myState.toDate}
                onChange={(e) => {
                  handleDate(e, 'toDate')
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                // maxDate={moment().toDate()}
             


              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
          
            <div className={styles.formDiv}>
       
            <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  onClick={() => handleSubmit()}
                  data-testid="confirm-action"
                >
                  SUBMIT
                </Button>
                <Button
          className={clsx(styles.actionButton, styles.resetButton)}
          variant="tertiary"
          onClick={handleOpen}
          style={{marginLeft: "10px"}}
        >
          CANCEL
        </Button>
            </div>
          </div> 
        </Grid>
      </Grid> */}
    </div>
  )
  const newKeySequence = [
    'id',
      'pers_no',
      'empl_name',
      'workarea',
      'bc_number',
      'bc_name',
      'grade_group',
      'company',
      'location',
      'mon',
      'exception_hrs',
      'status',

];
  function changeKeySequence(data, keySequence) {
    console.log(data);
    return data.map((dict) => {
      const newDict = {};
      keySequence.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(dict, key)) {
          newDict[key] = dict[key];
        }
      });
      return newDict;
    });
  }

  function downloadExcel(data) {
    const modifiedList = changeKeySequence(data, newKeySequence);
    console.log(modifiedList);
    const columnsKeys = {
      'id':'Id',
      'pers_no':'Ticket No',
      'empl_name':'EMP Name',
      'workarea':'Work Area',
      'bc_number':'BC No',
      'bc_name':'BC Description',
      'grade_group':'Grade Group',
      'company':'Company',
      'location':'Location',
      'mon':'Month',
      'exception_hrs':'Exception Hours',
      'status':'Status',
    }
    modifiedList.forEach((item, index) => {item.id = index + 1;});
    const updateExportData = modifiedList.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    console.log(updateExportData,'updateExportData');

    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'NOPOLinkageReport.xlsx');
  }
  
  const renderReport = () => (
    <div
      className={styles.formGroup}>
      {myState.tableFlag && allTableData?.length !== 0 && (
        <>
        <Grid
            container
            spacing={1}
            // className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
             {/* <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                  <label>Report Details:</label>
                </div>
              </div>
            </Grid> */}
            <Grid item md={12} lg={12} xs={12} sm={10}>
              <div className={styles.formDiv}>
      <div
      //  className={styles.customeTable}
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px"
        }}
      >
       
          <>
          <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME}/>
        {/* <Table
          viewDisplay={viewDisplay}          
          columns={baseDefaultColumns}
          defaultColumns={baseDefaultColumns}
          rowHeight={ROW_HEIGHT}
              rows={tableArray}
              secondaryActions={[
                {
                  name: "Export",
                  getFilteredData: true,
                  authOperation: "create-project",
                  shouldEnable: (tableArray) => tableArray,
                  actionFn: filteredData => {
                    // goTo(selected),
                    // handleExport(filteredData);
                    // ExportFile(filteredData)
                    downloadExcel(filteredData)
                  },
                },
              ]}
          setAsnCount={setCount}
          isDataLoading={false}
          actionButtons
        //    onRowSelect={(e) => { console.log('onRowSelect call') }}
        />
        <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={allTableData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                
              /> */}
          </>
              
      </div>
      </div>
      </Grid>
      </Grid>
      </>
     )} 
    </div>)



  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail
    }
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails }
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: '',
      suppRepresentativeName: '',
      suppRepresentativeContact: '',
      suppRepresentativeEmail: ''
    }
    dispatch({ type: 'update', field: 'inputFields', value: inputs });
    dispatch({ type: 'update', field: 'errors', value: {} });
  }

  const resetState = () => {
    dispatch({ type: 'reset' });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor('processInfoBg');
  }

  useEffect(() => {
    setTableArray(allTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  }, [rowsPerPage, page])

  useEffect(() => {
    if (resetAllVisitedFields)
      resetState();
  }, [resetAllVisitedFields])

  return (
    <>
      <div className={clsx(styles.scrollContainer, styles.formContainer)}>


        <CustomFormGroup header='No Linkage Report' body={renderOther()} />
        
{myState.tableFlag && tableData.length === 0 && (
  <>
{renderReport()}

</>
      )} 
        { loading ? (
    <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
         <Truckloading />
    </div>):""
}

      </div>

    
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />


    </>
  )
}


function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

ReportNoManager.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
ReportNoManager.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(ReportNoManager);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);